export default __webpack_public_path__ + "static/media/ic_dai_24.bafa9da6.svg";